import { componentTypes, Schema, validatorTypes } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface StaffSchemaData {
  email: string,
  editData?: any,
}

export const StaffSchema = (props: StaffSchemaData) => {
  const {
    editData,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Staff Email',
        placeholder: 'Staff Email',
        name: 'email',
        FormFieldGridProps: { xs: 12 },
        initialValue: editData?.email || '',
        validate: [{
          type: 'required',
          message: 'Staff email is required'
        },{
          type: validatorTypes.PATTERN,
          pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        }]
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
